import React, { Component } from "react";

class History extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <h1 className="page-header text-center head">Brief History</h1>
        <p>
          The Centre for Educational Research and Speech and Language Services
          for Families and Persons with Communication Disorders and Dyslexia
          Management under the NEW-AGE ACADEMY of EDUCATION AND RESEARCH (NAER)
          started in the early part of 2021. NAER has been a long time dream of
          Professor Grace Yawo Gadagbui since 1975 after the Specialist Training
          for the Deaf at Mampong- Akwapim in the Eastern Region, and this
          yearning persisted when she taught the children with hearing
          impairment in the Volta school for the Deaf, Hohoe in the Volta Region
          of Ghana. After further training in Communication Disorders and
          Sciences between 1981 to 1985, she obtained BSc and MSc, in
          Carbondale, Illinois USA as a Speech and Language Therapist.
        </p>
        <p>
          She returned to Volta School for the Deaf to teach for seven years as
          a Speech and Language Therapist. From 1992 to 1993 she earned another
          Master of Science (MSc.) In Paediatric Habilitation (Audiology),
          Manchester UK. From 1993 to 2020, two decades and seven years ago,
          when she was appointed a Lecturer in the University College of
          Education, Winneba, now the University of Education, Winneba she
          taught courses related to Speech and Language Deviations, Anatomy and
          Physiology of the Speech Mechanism, Paediatric Audiometry and
          supervised numerous Long Essays of undergraduates; Theses of M.Ed. and
          MPhil candidates and served as External Supervisor of Theses and sat
          on Promotion Boards etc.
        </p>
        <p>
          During such programmes, a lot of experiences had been obtained
          including gaps and specific areas students and researchers found
          difficult in Research. These among others that prompted the Professor
          to open a centre to support and direct Researchers, Families and
          Persons With Disabilities to have their problems addressed by some
          selected Experts in the academia and to lend learners, support in
          writing Projects, Seminar Papers, Long Essays, Theses and
          Dissertations and above all; impact presentational skills of
          Viva-Voce; assist in publication of Research Reports in Refereed
          Journals and Review of Papers, among others.
        </p>
        <p>
          Guidance in teaching and writing research papers can be done on
          individual or group basis. Application of research findings to real
          life situations and disseminations will be endorsed. Analyses of
          educational policies will also be core functions of the NAER.
          Workshops and Seminars will form core activities for teachers in both
          public and private schools, Resource Teachers and Coordinators in the
          field; students, families and persons with disabilities, community
          members and all stake holders who have the interest at heart to
          promote the education, and the inclusivity and livelihood of Persons
          With Special Needs, will form part of the activities of (NAER).
        </p>
      </div>
    );
  }
}

export default History;
